<template>
  <div class="catalog-plans" id="catalog-plans">
		<v-flex text-xs-center xs12 class="title-catalog-plans newwarning--text">
			Todos nuestros planes incluyen <span class="span-title w-heavy">Venta Online + Facturación Electrónica</span>
		</v-flex>
		<v-flex text-xs-center class="mt-4 newwarning--text subtitle-plans">
			Elige el Plan que más se acomode a tus necesidades
		</v-flex>
		<v-layout class="mobile-none" justify-center mt-4>
			<v-flex xs2 text-xs-center>
				<img src="/static/images-new/icons/arrow-orange.svg" alt="">
			</v-flex>
			<v-flex xs2 text-xs-center>
				<img src="/static/images-new/icons/arrow-orange.svg" alt="">
			</v-flex>
		</v-layout>
			<v-flex class="layout h-100" mt-4 justify-center wrap>
					<v-flex v-for="(item, index) in plans" :key="index" sm12 md2 mx-4>
						<v-layout align-center column class="h-100">
							<v-flex text-xs-center class="section-plans">
								<p class="title-plan primary--text w-heavy">{{ item.name }}</p>
								<p class="w-heavy text-orange description-plan">{{ item.description }}</p>
							</v-flex>
							<v-flex class="step-plan mt-4 h-100">
								<v-flex text-xs-center class="circle">{{item.id}}</v-flex>
									<p class="newwarning--text w-bold mt-2 ml-4">{{item.step.step}} <span class="w-medium">{{item.step.description}}</span></p>
									<v-layout align-start column wrap>
										<v-flex v-for="(check, index) in item.step.checks" :key="index">
											<v-layout row>
												<v-flex text-xs-left>
													<img src="/static/images-new/icons/check-orange.svg" height="14">
												</v-flex>
												<v-flex ml-2 class="newwarning--text">
													{{ check.name }}
												</v-flex>
											</v-layout>
										</v-flex>
									</v-layout>
								</v-flex>
						</v-layout>
					</v-flex>
			</v-flex>
		<v-flex xs12 class="newwarning--text mt-5 max-width-discount w-medium" text-xs-center>
			Por lanzamiento tenemos <span class="primary--text w-heavy">50% de descuento</span> en todos nuestros planes. Obtén tu código de descuento <a :href="whatsappLink" target="_blank" class="text-orange w-black">AQUÍ</a>
		</v-flex>
		<v-flex xs12 text-xs-center mt-5>
			<a :href="whatsappLink" target="_blank" class="href-depressed">
				<button class="href-wssp w-bold">
					<v-layout align-center>
						<v-flex xs2>
							<img src="/static/images-new/icons/whatsapp-white.svg" alt="">
						</v-flex>
						<v-flex class="ml-3 text-wssp" text-xs-left>
							Deseo más información
						</v-flex>
					</v-layout>
				</button>
			</a>
		</v-flex>
	</div>
</template>

<script>
function whatsappLink() {
	const reg = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
	if (reg.test(navigator.userAgent)) {
		return `https://api.whatsapp.com/send?phone=${process.env.WHATSAPP_NUMBER}`;
	}
	return `https://web.whatsapp.com/send?phone=${process.env.WHATSAPP_NUMBER}`;
}
function data() {
	return {
		plans: [
			{
				id: 1,
				name: 'PLAN DESPEGUE',
				description: 'Desde S/35 al mes*',
				step: {
					id: 1,
					step: 'Primer paso,',
					description: 'para iniciar tu viaje digital:',
					checks: [
						{
							id: 1,
							name: 'Tienda Online que te permite recibir pedidos por WhatsApp',
						},
						{
							id: 2,
							name: 'Facturación Electrónica ',
						},
						{
							id: 3,
							name: 'Medios de Pago Online',
						},
					],
				},
			},
			{
				id: 2,
				name: 'PLAN EMPRENDEDOR',
				description: 'Desde S/75 al mes*',
				step: {
					id: 2,
					step: 'Segundo paso,',
					description: 'para escalar tu empresa:',
					checks: [
						{
							id: 1,
							name: '500 productos en tu catálogo',
						},
						{
							id: 2,
							name: 'Tienda Online con Facebook Live',
						},
						{
							id: 3,
							name: 'SEO',
						},
						{
							id: 4,
							name: 'Control de Stock y Kardex',
						},
						{
							id: 5,
							name: '2 Tiendas Físicas',
						},
						{
							id: 6,
							name: 'Cupones de descuento',
						},
					],
				},
			},
			{
				id: 3,
				name: 'PLAN PRO',
				description: 'Desde S/149 al mes*',
				step: {
					id: 3,
					step: 'Tercer Paso,',
					description: 'da el salto al mundo de las ventas por mobile:',
					checks: [
						{
							id: 1,
							name: 'App de Pedidos Personalizada',
						},
						{
							id: 2,
							name: 'Ecommerce Web',
						},
						{
							id: 3,
							name: 'Reseñas de Clientes',
						},
						{
							id: 4,
							name: 'Módulo de Caja y Tesorería',
						},
						{
							id: 5,
							name: 'Rutas de Distribución para Delivery',
						},
					],
				},
			},
		],
		steps: [
			{
				id: 1,
				step: 'Primer paso,',
				description: 'para iniciar tu viaje digital:',
				checks: [
					{
						id: 1,
						name: 'Tienda Online que te permite recibir pedidos por WhatsApp',
					},
					{
						id: 2,
						name: 'Facturación Electrónica ',
					},
					{
						id: 3,
						name: 'Medios de Pago Online',
					},
				],
			},
			{
				id: 2,
				step: 'Segundo paso,',
				description: 'para escalar tu empresa:',
				checks: [
					{
						id: 1,
						name: '500 productos en tu catálogo',
					},
					{
						id: 2,
						name: 'Tienda Online con Facebook Live',
					},
					{
						id: 3,
						name: 'SEO',
					},
					{
						id: 4,
						name: 'Control de Stock y Kardex',
					},
					{
						id: 5,
						name: '2 Tiendas Físicas',
					},
					{
						id: 6,
						name: 'Cupones de descuento',
					},
				],
			},
			{
				id: 3,
				step: 'Tercer Paso,',
				description: 'da el salto al mundo de las ventas por mobile:',
				checks: [
					{
						id: 1,
						name: 'App de Pedidos Personalizada',
					},
					{
						id: 2,
						name: 'Ecommerce Web',
					},
					{
						id: 3,
						name: 'Reseñas de Clientes',
					},
					{
						id: 4,
						name: 'Módulo de Caja y Tesorería',
					},
					{
						id: 5,
						name: 'Rutas de Distribución para Delivery',
					},
				],
			},
		],
	};
}
export default {
	name: 'catalog-plans',
	data,
	computed: {
		whatsappLink,
	},
};
</script>

<style lang="scss" scoped>
.catalog-plans {
	background-image: linear-gradient(to bottom, #ffffff 2%, #f5fbfb);
	padding: 26px 38px 40px 38px;
	
	@media (min-width: 936px) {
		background-image: linear-gradient(to bottom, #ffffff 45%, #f5fbfb);
		padding: 26px 0 40px 0;
	}
}
.title-catalog-plans {
	font-size: 20px;
	@media (min-width: 936px) {
		font-size: 22px;
	}
}
.span-title {
	color: #ff5c00;
}

.subtitle-plans {
	font-size: 16px;

	@media (min-width: 936px) {
		font-size: 24px;
	}
}

.section-plans {
	background-color: white;
	border: solid 1.5px map-get($colors, primary);
	border-radius: 15px;
	width: 233px !important;
	padding: 19px 0;
	&:first-child {
		margin-left: 0px;
	}
}
.title-plan {
	font-size: map-get($sizes, medium);
	margin-bottom: 5px !important;
}

.text-orange {
	color: color(newprimary);
	text-decoration: none;
}
.description-plan {
	font-size: map-get($sizes, medium19);
	margin: 0;
}
.step-plan {
	background-color: map-get($colors, white);
	border: 3px solid map-get($colors, newbackground);
	border-radius: 12px;
	height: 309px;
	padding: 19px 13px;
	max-width: 271px !important;
}

.circle {
	background-color: map-get($colors, warning);
	border-radius: 50%;
	color: map-get($colors, white);;
	font-size: map-get($sizes, large24);
	font-weight: map-get($weight, bold);
	height: 58px;
	margin: 0 auto;
	max-width: 58px;
	padding: 10px 0;
}
.max-width-discount {
	font-size: map-get($sizes, medium16);
	margin: 0 auto;
	max-width: 655px;
	text-decoration: none;
	@media (min-width: 936px) {
		font-size: map-get($sizes, medium18);
	}
}
.href-wssp {
	background: #64b161;
	border-radius: 25.5px;
	box-shadow: 0 2px 6px 0 rgba(158, 158, 158, 0.5);
	color: map-get($colors, white);
	max-width: 165px;
	padding: 9px 9px 9px 22px;
	text-decoration: none;
}
.text-wssp {
	line-height: 1;
}

.column {
	margin-left: 16px;

	@media (max-width: 980px) {
		margin: 16px 0 0 0px;
		flex-direction: column;
	}
}
.mobile-none {
	display: none;
	@media (min-width: 936px) {
		display: flex;
	}
}

.h-100 {
	height: 100%;
}
</style> 



// WEBPACK FOOTER //
// src/components/home-new/catalog-plans.vue